import { LoginPage } from '../pages/Auth/LoginPage';
import { RegisterOnboarding } from '../pages/Auth/RegisterOnboarding';
import { RegisterPage } from '../pages/Auth/RegisterPage';
import { ForgotPasswordPage } from '../pages/Auth/ForgotPasswordPage';
import { ResetPasswordPage } from '../pages/Auth/ResetPasswordPage';

/**
 * Rutas de autenticación - Solo accesibles cuando NO estás autenticado
 * Redirigen a /home si ya hay sesión activa
 * No incluyen Layout (Header/Footer)
 */
export const authRoutes = [
    {
        path: '/login',
        exact: false,
        component: LoginPage,
        name: 'Login',
        description: 'Página de inicio de sesión'
    },
    {
        path: '/register',
        exact: true,
        component: RegisterOnboarding,
        name: 'Selección de tipo',
        description: 'Selección de tipo de usuario'
    },
    {
        path: '/register-2',
        exact: false,
        component: RegisterPage,
        name: 'Formulario de Registro',
        description: 'Formulario de registro'
    },
    {
        path: '/auth/forgot-password',
        exact: true,
        component: ForgotPasswordPage,
        name: 'Recuperar Contraseña',
        description: 'Solicitar restablecimiento de contraseña por email'
    },
    {
        path: '/auth/reset-password',
        exact: true,
        component: ResetPasswordPage,
        name: 'Restablecer Contraseña',
        description: 'Formulario para establecer una nueva contraseña con token'
    }
];
